import {CAMPAIGN_KEYS} from "@/api/campaignApi";
import {CAMPAIGN_REQUEST_KEYS} from "@/api/campaignApplicationApi";
import {invalidateTickets} from "@/api/reviewTicketsApi";
import InputField from "@/components/Common/forms/InputField";
import Modal from "@/components/Common/Modal";
import {client} from "@/httpClient";
import useCampaignInfluencerFilterStore from "@/store/campaignInfluencerFilter";
import {declineCancellationRequestModalDataAtom} from "@/store/jotaiAtoms";
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {useAtom} from "jotai";
import {useState, type FC} from "react";
import {useTranslation} from "react-i18next";

const DeclineCancellationRequestModal: FC = () => {
  const {t} = useTranslation("campaign_active");
  const queryClient = useQueryClient();
  const searchParam = useCampaignInfluencerFilterStore(state => state.filters.search);
  const [data, setData] = useAtom(declineCancellationRequestModalDataAtom);
  const [adminReason, setAdminReason] = useState("");

  const closeModal = () => {
    setAdminReason("");
    setData(null);
  };

  const {mutate: declineRequest, isPending} = useMutation({
    mutationKey: CAMPAIGN_REQUEST_KEYS.mDeclineCampaignRequest(data!.requestId),
    mutationFn: () =>
      client.post(CAMPAIGN_REQUEST_KEYS.mDeclineCampaignRequest(data!.requestId)[0], {admin_reason: adminReason}),
    onSuccess: () => {
      [
        CAMPAIGN_KEYS.qCampaignActiveApplications(data!.campaignId, searchParam),
        CAMPAIGN_KEYS.qCampaignPreparationApplications(data!.campaignId, false, searchParam),
      ].forEach(queryKey => queryClient.invalidateQueries({queryKey}));
      // Declining also resolves the request's Admin Hub queue record server-side;
      // refetch so the card leaves the queue when the modal was opened from there.
      invalidateTickets();
      closeModal();
    },
  });

  return (
    <Modal
      backgroundClassName="max-w-104"
      confirmButtonText={t("decline_cancellation_request")}
      isConfirmDisabled={!adminReason.trim()}
      isLoading={isPending}
      modalTitle={t("decline_cancellation_request")}
      negativeButtonText={t("cancel")}
      onClose={closeModal}
      onConfirm={() => declineRequest()}
      shouldCloseOnConfirm={false}>
      <InputField
        autoFocus
        label={t("decline_cancellation_request_reason_label")}
        onChange={setAdminReason}
        value={adminReason}
      />
    </Modal>
  );
};

export default DeclineCancellationRequestModal;
